module.exports = __webpack_public_path__ + "/images/cover-ext-install.133abf9.png";